import tw, { styled } from 'twin.macro';

export const StyledHeader = styled.header`
	${tw`border-b border-gray-200`}
`;
